import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { PATTERN_BACKGROUND_VARIANT, PATTERN_BACKGROUND_MASK } from "../utils.js";
const patternBackgroundVariants = tv({
  base: "relative text-clip",
  variants: {
    variant: {
      [PATTERN_BACKGROUND_VARIANT.Grid]: "bg-[linear-gradient(to_right,var(--foreground)_1px,transparent_1px),linear-gradient(to_bottom,var(--foreground)_1px,transparent_1px)]",
      [PATTERN_BACKGROUND_VARIANT.Dot]: "bg-[radial-gradient(var(--foreground)_1px,transparent_1px)]",
      [PATTERN_BACKGROUND_VARIANT.BigDot]: "bg-[radial-gradient(var(--foreground)_3px,transparent_3px)]"
    },
    size: {
      xs: "bg-[size:8px_8px]",
      sm: "bg-[size:16px_16px]",
      md: "bg-[size:24px_24px]",
      lg: "bg-[size:32px_32px]"
    }
  },
  defaultVariants: {
    variant: "grid",
    size: "md"
  }
}), patternBackgroundMaskVariants = tv({
  base: "bg-background",
  variants: {
    mask: {
      [PATTERN_BACKGROUND_MASK.Ellipse]: "[mask-image:radial-gradient(ellipse_at_center,transparent,black_80%)]",
      [PATTERN_BACKGROUND_MASK.EllipseTop]: "[mask-image:radial-gradient(ellipse_at_top,transparent,black_80%)]"
    }
  },
  defaultVariants: {
    mask: "ellipse"
  }
});
export {
  patternBackgroundMaskVariants,
  patternBackgroundVariants
};
//# sourceMappingURL=index.js.map
